import * as fromDatatype from '../datatype-library/index';
export interface bl_fi_my_einvoice_from_irb_document_cache_RowInterface {
  	guid: fromDatatype.GuidDataFieldInterface;
	lhdn_document_guid: fromDatatype.GuidDataFieldInterface;
	lhdn_submission_guid: fromDatatype.GuidDataFieldInterface;
	lhdn_internal_id: fromDatatype.VarcharDatatypeInterface;
	einvoice_type_name: fromDatatype.VarcharDatatypeInterface;
	property_json: any;
	namespace: fromDatatype.VarcharDatatypeInterface;
	acl_policy: any;
	acl_config: any;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.VarcharDatatypeInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_my_einvoice_from_irb_document_cache_RowClass
  implements bl_fi_my_einvoice_from_irb_document_cache_RowInterface {
	guid: fromDatatype.GuidDataFieldInterface;
	lhdn_document_guid: fromDatatype.GuidDataFieldInterface;
	lhdn_submission_guid: fromDatatype.GuidDataFieldInterface;
	lhdn_internal_id: fromDatatype.VarcharDatatypeInterface;
	einvoice_type_name: fromDatatype.VarcharDatatypeInterface;
	property_json: any;
	namespace: fromDatatype.VarcharDatatypeInterface;
	acl_policy: any;
	acl_config: any;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.VarcharDatatypeInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VarcharDatatypeInterface;
}
